import { render } from "./BaseDataCard.vue?vue&type=template&id=c1b7e874"
import script from "./BaseDataCard.vue?vue&type=script&lang=js"
export * from "./BaseDataCard.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__